<template>
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>排行榜详情</span></div>
                        </el-form-item>
                        <el-form-item label="搜索：">
                            <el-input size="small" v-model="formInline.params.keyword" placeholder="输入关键字"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <el-card class="box-card box-cards2" shadow="never">
            <!--列表-->
            <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
                style="width: 100%; " v-loading="loading">
                <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="120"></el-table-column>
                <el-table-column prop="ranking" label="	排名" align="center" width="100"></el-table-column>
                <el-table-column prop="points" label="积分" align="center"></el-table-column>
                <el-table-column prop="createTime" label="进榜日期" align="center"></el-table-column>
                <el-table-column prop="winAward" label="状态" align="center" width="140">
                    <template slot-scope="scope">
                        <div>{{ scope.row.winAward == 0 ? '-' : getAward(scope.row.winAward) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="jtime" label="更新时间" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.createTime | timestampToTime }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isShipped == 0" size="mini" type="primary"
                            @click="handleEdit(scope.$index, scope.row)">处理 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-card>

    </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { userrankdetail } from "../../api/userMG";
export default {
    data() {
        return {
            title: "信息",
            options: [],
            editFormVisible: false,
            //分页
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
            tableData: [], //表格数据 
            formInline: {
                data: {},
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    id: ""
                },
            },
            dialogImageUrl: '',
            dialogVisible: false,
            //添加，修改数据
            editForm: {
                data: {},
                params: {
                    "id": 1,
                    "trackingNumber": "",
                    "shippingCompany": ""
                },
            },
            //规则验证
            rules: {},
        };
    },
    components: {
        Pagination
    },
    created() {
        this.formInline.params.id = this.$route.query.id;
        //数据列表
        this.getlist(this.formInline);
    },
    methods: {
        headStyle() {
            return {
                background: "#A1BBFF",
                color: "#fff",
                letterSpacing: "2px",
                border: " 1px solid #A1BBFF",
                textAlign: "center",
                height: "39px",
            };
        },
        getAward(award) {
            if (award == 1) {
                return '闪过侠玩偶'
            } else if (award == 2) {
                return '闪过侠挂件'
            }
            return '-'
        },
        //显示数据
        getlist(parameter) {
            this.loading = true;
            userrankdetail(parameter)
                .then((res) => {
                    this.loading = false;
                    // console.log("userlist", res);
                    if (res.code != 200) {
                        this.$message({
                            type: "info",
                            message: res.message,
                        });
                    } else {
                        this.tableData = res.data.records;
                        // 分页赋值
                        this.pageparm.currentPage = this.formInline.params.pageNum;
                        this.pageparm.pageSize = this.formInline.params.pageSize;
                        this.pageparm.total = res.data.total;
                        // console.log(this.tableData)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("加载失败，请稍后再试！");
                });
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.params.pageNum = parm.currentPage;
            this.formInline.params.pageSize = parm.pageSize;
            this.getlist(this.formInline);
        },
        // 搜索事件
        search() {
            this.formInline.params.pageNum = 1;
            this.getlist(this.formInline); //显示
        },
        //关闭弹框
        handleClose(done) {
            this.$confirm("还有未保存的工作哦确定关闭吗？")
                .then((_) => {
                    this.editFormVisible = false
                    // done();
                })
                .catch((_) => { });
        },
        //上传头像


        //添加，修改
        handleEdit(index, row) {
            this.editFormVisible = true;
            this.editForm = {

                data: {},
                params: {
                    "id": row.id,
                    "trackingNumber": "",
                    "shippingCompany": "",
                },
            }


        },
        //提交添加，修改
        submitForm(info) {

            debounce(() => {

                shippingupdate(this.editForm)
                    .then(res => {
                        if (res.code == 200) {
                            this.editFormVisible = false;
                            this.getlist(this.formInline);
                            this.$message({
                                message: "保存成功！",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                type: "info",
                                message: res.message,
                            });
                        }
                    })
                    .catch((err) => {
                        this.editFormVisible = false;
                        this.$message.error("保存失败，请稍后再试！");
                    });



            }, 1500);
        },

    },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.divBox {
    /*flex-direction: row;*/
    float: left;
    position: relative;
    margin-right: 10px;
}

.imgSty {
    margin-left: 3px;
}

.delIcon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 145px;
    height: 145px;
    line-height: 145px;
    text-align: center;
}

.avatar {
    width: 145px;
    height: 145px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/userrank/detail.vue